import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcstudent/latestblogs/LatestBlogs.css";
import BlogCard from "../../../components/gcstudent/blogcard/BlogCard";

const LatestBlogs = () => {
  const { baseUrl } = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  /* ── Fetch latest 3 blogs ── */
  useEffect(() => {
    axios
      .get(`${baseUrl}/general/blogs/fetchAllBlogs`)
      .then((res) => {
        if (res.data.success === true) {
          const mapped = res.data.blogs
            .map((b) => ({
              id: b.id,
              title: b.title || "",
              author: b.author || "",
              category: b.category || "General",
              date: b.created_at
                ? new Date(b.created_at).toLocaleDateString("en-PK", {
                    year: "numeric", month: "short", day: "numeric",
                  })
                : "",
              excerpt: b.excerpt || "",
              content: b.content || "",
              tags: Array.isArray(b.tags)
                ? b.tags
                : (typeof b.tags === "string" ? JSON.parse(b.tags || "[]") : []),
              imgSrc: b.img ? `${baseUrl.replace("/api", "")}/storage/${b.img}` : "",
              imgAlt: b.title || "",
              createdAtRaw: b.created_at,
            }))
            .sort((a, b) => new Date(b.createdAtRaw) - new Date(a.createdAtRaw))
            .slice(0, 3);

          setBlogs(mapped);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [baseUrl]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  /* ── Navigate to full blog page, pre-selecting this blog's detail ── */
  const openBlog = (blog) => {
    navigate("/blogs", { state: { blogId: blog.id } });
  };

  return (
    <section className="gcStudent-lblogs-section" ref={sectionRef}>
      <Container>
        {/* Header */}
        <div
          className={`gcStudent-lblogs-header ${
            isVisible ? "gcStudent-lblogs-header--visible" : ""
          }`}
        >
          <h2 className="gcStudent-lblogs-title">Latest Blogs</h2>
          <p className="gcStudent-lblogs-subtitle">
            Stay updated with educational articles and tips
          </p>
        </div>

        {/* Blog Cards — 3 per row */}
        {!loading && blogs.length > 0 && (
          <Row className="gcStudent-lblogs-row justify-content-center">
            {blogs.map((blog, index) => (
              <Col
                key={blog.id}
                xs={12}
                sm={6}
                md={4}
                className="gcStudent-lblogs-col"
              >
                <div
                  className={`gcStudent-lblogs-card-wrapper ${
                    isVisible ? "gcStudent-lblogs-card-wrapper--visible" : ""
                  }`}
                  style={{ animationDelay: `${0.12 + index * 0.15}s` }}
                >
                  <BlogCard
                    image={blog.imgSrc}
                    category={blog.category}
                    title={blog.title}
                    excerpt={blog.excerpt}
                    author={blog.author}
                    date={blog.date}
                    onClick={() => openBlog(blog)}
                  />
                </div>
              </Col>
            ))}
          </Row>
        )}

        {!loading && blogs.length === 0 && (
          <p className="gcStudent-lblogs-empty">No blogs published yet.</p>
        )}

        {/* View All Blogs Button */}
        <div
          className={`gcStudent-lblogs-footer ${
            isVisible ? "gcStudent-lblogs-footer--visible" : ""
          }`}
        >
          <button
            className="gcStudent-lblogs-view-btn"
            onClick={() => navigate("/blogs")}
          >
            View All Blogs
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="gcStudent-lblogs-arrow"
            >
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </Container>
    </section>
  );
};

export default LatestBlogs;